/**
 * ISO 639-1 language code → display metadata.
 * Used across the CMS admin UI for config-driven language rendering.
 */
const LANGUAGE_DISPLAY = {
  en: { name: 'English', flag: '🇬🇧', direction: 'ltr' },
  fi: { name: 'Finnish', flag: '🇫🇮', direction: 'ltr' },
  ms: { name: 'Malay', flag: '🇲🇾', direction: 'ltr' },
  ar: { name: 'Arabic', flag: '🇸🇦', direction: 'rtl' },
  zh: { name: 'Chinese', flag: '🇨🇳', direction: 'ltr' },
  ja: { name: 'Japanese', flag: '🇯🇵', direction: 'ltr' },
  es: { name: 'Spanish', flag: '🇪🇸', direction: 'ltr' },
  fr: { name: 'French', flag: '🇫🇷', direction: 'ltr' },
  de: { name: 'German', flag: '🇩🇪', direction: 'ltr' },
  sv: { name: 'Swedish', flag: '🇸🇪', direction: 'ltr' },
  nb: { name: 'Norwegian', flag: '🇳🇴', direction: 'ltr' },
  it: { name: 'Italian', flag: '🇮🇹', direction: 'ltr' },
  pt: { name: 'Portuguese', flag: '🇵🇹', direction: 'ltr' },
  ru: { name: 'Russian', flag: '🇷🇺', direction: 'ltr' },
  ko: { name: 'Korean', flag: '🇰🇷', direction: 'ltr' },
  th: { name: 'Thai', flag: '🇹🇭', direction: 'ltr' },
  vi: { name: 'Vietnamese', flag: '🇻🇳', direction: 'ltr' },
  id: { name: 'Indonesian', flag: '🇮🇩', direction: 'ltr' },
  hi: { name: 'Hindi', flag: '🇮🇳', direction: 'ltr' },
  ta: { name: 'Tamil', flag: '🇮🇳', direction: 'ltr' },
};

/**
 * Get display info for a language code. Falls back to code as name.
 */
export function getLanguageDisplay(code) {
  return LANGUAGE_DISPLAY[code] || { name: code, flag: '🌐', direction: 'ltr' };
}

/**
 * Build a { code: { name, flag, direction } } map from an array of ISO codes.
 */
export function buildLanguageMap(codes) {
  const map = {};
  for (const code of codes) {
    map[code] = getLanguageDisplay(code);
  }
  return map;
}

/**
 * Build dropdown options from ISO codes: [{ value: 'en', label: 'English 🇬🇧' }, ...]
 */
export function buildLanguageOptions(codes) {
  return codes.map(code => {
    const info = getLanguageDisplay(code);
    return { value: code, label: `${info.name} ${info.flag}` };
  });
}

/**
 * Format a list of language names for display.
 * e.g. ['English', 'Finnish'] → "English + Finnish"
 */
export function formatLanguageList(codes) {
  const names = codes.map(c => getLanguageDisplay(c).name);
  return names.join(' + ');
}

export default LANGUAGE_DISPLAY;
